import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OnChange } from '@df/ng/on-change';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { Subject } from 'rxjs/internal/Subject';
import { AbstractCmsBlockComponent } from '../../../../cms/block/abstract-cms-block.component';
import { CheckoutAccountNewComponent } from '../checkout-account-new.component';
import { CHECKOUT_ACCOUNT_NEW_CMS_CONFIG } from './checkout-account-new-cms.config';
import { NCheckoutAccountNewCms } from './checkout-account-new-cms.interface';

@Component({
    selector: 'checkout-account-new-cms',
    templateUrl: './checkout-account-new-cms.component.html',
    styleUrl: './checkout-account-new-cms.component.scss',
    standalone: true,
    imports: [CheckoutAccountNewComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CheckoutAccountNewCmsComponent>(CHECKOUT_ACCOUNT_NEW_CMS_CONFIG)
export class CheckoutAccountNewCmsComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: NCheckoutAccountNewCms.IData;

    @Input()
    @OnChange(function (value: boolean) {
        if (this.showSubscriptionOptInChange) {
            this.showSubscriptionOptInChange.emit(value);
        }
    })
    set showSubscriptionOptIn(value: boolean) {
        this._showSubscriptionOptIn = value;
    }

    get showSubscriptionOptIn(): boolean {
        return this._showSubscriptionOptIn;
    }
    private _showSubscriptionOptIn = false;

    @Output()
    showSubscriptionOptInChange = new EventEmitter<boolean>();

    override canDetach = false;
    detectChanges$ = new Subject<void>();

    override detectChanges(changes?: NICmsContentComponent.IDetectionChanges): void {
        const watchPath = ['content', 'blocks'];

        if (
            watchPath.some(path => (changes?.['content'] as NICmsContentComponent.Mutation)?.changeEvent?.valuePath?.includes(path)) ||
            watchPath.some(path => !!(changes?.['content'] as NICmsContentComponent.Change)?.currentValue?.[path])
        ) {
            this.detectChanges$.next();
        }

        super.detectChanges();
    }
}
